/**
 * shouldQueue(err, isOnline) — central guard for "should this error trigger
 * an offline-queue write instead of bubbling up to the UI as a hard failure?"
 *
 * The previous inline check (`!isOnline || err.message?.includes("fetch") ||
 * err.message?.includes("Network")`) was too narrow: Chrome's DevTools
 * "Offline" mode produces `err.message === "net::ERR_INTERNET_DISCONNECTED"`,
 * which matches neither "fetch" nor "Network". Result: the queue was never
 * written, and the cashier saw a silent failure.
 *
 * This helper is the single source of truth. It is called from
 * src/components/TransactionForm.tsx (the two earn/redeem catch blocks).
 *
 * Per Group D audit §6.1 Task 2.
 */

export function shouldQueue(err: unknown, isOnline: boolean): boolean {
  if (!isOnline) return true;
  if (typeof navigator !== "undefined" && !navigator.onLine) return true;
  if (!err) return false;

  const msg = String(
    (err as { message?: unknown })?.message ?? err
  ).toLowerCase();

  return (
    msg.includes("fetch") ||
    msg.includes("network") ||
    msg.includes("failed to fetch") ||
    msg.includes("err_internet_disconnected") ||
    msg.includes("err_network_changed") ||
    msg.includes("err_name_not_resolved") ||
    msg.includes("err_connection") ||
    msg.includes("err_timed_out") ||
    msg.includes("err_aborted") ||
    msg.includes("timed out") ||
    msg.includes("aborted")
  );
}
